<script>
var current_tms_route_table = 0;
var current_tms_task_table = 0;

export default
{
    current_tms_route_table,
    current_tms_task_table
}
</script>